<script>
import store from '@/store/store'
import { gmapApi } from 'vue2-google-maps'
import { mapState } from 'vuex'
import { remove } from '../../api/map.api'

export default {
  name: 'BaseGoogleMapComponent',
  components: {
    MapCrudComponent: () => import('@/components/map/MapCrudComponent'),
    SubmitGroup: () => import('@/components/SubmitGroup'),
    BaseDialogTitle: () => import('@/components/BaseDialogTitle')
  },
  data() {
    return {
      defaultElementConfig: {
        strokeOpacity: 0.8,
        strokeWeight: 1.5,
        fillOpacity: 0.4,
        editable: false,
        draggable: false
      },
      mapCrudData: null,
      showMapCrud: false,
      dialog: {
        show: false,
        component: this.MapCrudComponent,
        loading: true,
        submited: false
      },
      closeOnSubmit: false,
      infoWindow: null,
      selectedShape: null,
      allLayers: [],
      showLabels: false,
      markers: [],
      infoWinOpen: false
    }
  },
  computed: {
    google: gmapApi,
    ...mapState('map', ['pois']),
    isPoiPage() {
      return this.$route.path == '/map/poi'
    }
  },
  mounted() {
    var interval = setInterval(() => {
      if (this.$refs.map && this.google) {
        this.google.maps.event.addListener(
          this.$refs.map.$mapObject,
          'rightclick',
          event => {
            this.drawPoiOnRightClick(event)
          }
        )
        clearInterval(interval)
      }
    }, 300)
  },

  watch: {
    pois: {
      handler() {
        this.removeAllLayers()
        this.handlePoisDrawing()
        this.zoomToPois()
      }
    },
    showLabels: {
      handler() {
        if (this.showLabels) {
          this.createPoiMarkers()
          this.infoWinOpen = true
        } else {
          this.markers = []
        }
      }
    }
  },
  methods: {
    showLabelsHandler() {
      this.showLabels = !this.showLabels
    },
    createPoiMarkers() {
      this.pois.forEach(el => {
        let marker = this.createMarkerAndInfoObject(el)
        this.markers.push(marker)
      })
    },
    createMarkerAndInfoObject(poi) {
      let position = {
        lat: poi.coordinates[0].latitude,
        lng: poi.coordinates[0].longitude
      }
      let content = `<h3>${poi.name}</h3>`
      let infoOptions = {
        content: content,
        pixelOffset: {
          width: 0,
          height: 0
        },
        maxWidth: 150
      }
      return { position, infoOptions }
    },
    removeAllLayers() {
      this.allLayers.forEach(l => {
        l.setMap(null)
      })
      this.allLayers = []
    },
    zoomToPois() {
      if (this.pois.length) {
        let bounds = new this.google.maps.LatLngBounds()
        this.pois.forEach(poi => {
          if (poi.type === 0) {
            poi.coordinates.forEach(coordinate => {
              bounds.extend(
                new this.google.maps.LatLng(
                  coordinate.latitude,
                  coordinate.longitude
                )
              )
              bounds.extend(
                new this.google.maps.LatLng(
                  coordinate.latitude + 1 / (111111 / poi.radius),
                  coordinate.longitude
                )
              )

              bounds.extend(
                new this.google.maps.LatLng(
                  coordinate.latitude - 1 / (111111 / poi.radius),
                  coordinate.longitude
                )
              )
            })
          } else {
            poi.coordinates.forEach(coordinate => {
              bounds.extend(
                new this.google.maps.LatLng(
                  coordinate.latitude,
                  coordinate.longitude
                )
              )
            })
          }
        })

        this.$refs.map.$mapObject.fitBounds(bounds)
      }
    },
    drawPoiOnRightClick(e) {
      let circleProperties = {
        center: {
          lat: e.latLng.lat(),
          lng: e.latLng.lng()
        },
        radius: 500,
        fillColor: '#1CE',
        ...this.defaultElementConfig
      }
      let circle = new this.google.maps.Circle(circleProperties)

      circle._id = ''
      circle._poiName = ''
      circle._restrictionType = ''
      circle._color = '#1CE'
      circle._type = 0

      let data = {
        circle: circle,
        eventType: 'CIRCLE'
      }

      this.handleMapCrudComponentVisibility(data)
    },
    handleMapCrudComponentVisibility(data) {
      this.mapCrudData = data
      this.dialog.show = true
    },
    onCloseDialogHandler() {
      this.dialog.show = false
    },
    onSubmitDialogHandler() {
      this.dialog.submited = true
    },
    handleMapCrudComponentClose(notification) {
      this.mapCrudData = {}
      store.dispatch('notification/add', notification, { root: true })
      this.dialog.submited = false
      this.dialog.show = false
    },
    handlePoisDrawing() {
      if (this.pois.length) {
        this.pois.forEach(poi => {
          if (poi.type == 0) {
            this.handleCircularPoiDrawing(poi)
          }

          if (poi.type == 1) {
            this.handlePolygonPoiDrawing(poi)
          }
        })
      }
    },
    // CircularPoi
    handleCircularPoiDrawing(poi, editable = false) {
      if (this.infoWindow && this.infoWindow.setMap) {
        this.infoWindow.setMap(null)
        this.infoWindow = null
      }
      let coordinate = this.prepareCircleCoordinateForGoogleMaps(
        poi.coordinates[0]
      )
      let center = coordinate
      let radius = poi.radius
      let fillColor = poi.color
      let circleProperties = {
        center,
        radius,
        fillColor,
        ...this.defaultElementConfig
      }

      let circle = new this.google.maps.Circle(circleProperties)
      circle._id = poi.id
      circle._poiName = poi.name
      circle._poiTime = poi.allowedStayMinutes
      circle._color = poi.color
      circle._restrictionType = poi.restriction
      circle._type = poi.type
      circle._contacts = poi.contacts
      circle._hasParking = poi.hasParking
      circle._objectType = poi.objectType
      circle._unloadPlaceType = poi.unloadPlaceType
      circle._pointOfInterestType = poi.pointOfInterestType
      circle._partnerCode = poi._partnerCode
      circle._hasRamp = poi._hasRamp
      circle._hasForklift = poi._hasForklift
      circle._specialPermitRequired = poi._specialPermitRequired
      circle._posClientId = poi._posClientId
      circle._businessUnitId = poi._businessUnitId

      circle.editable = editable
      circle.draggable = editable

      let infoWindow = new this.google.maps.InfoWindow({
        content: `
          <p>${poi.name}</p>
          ${
            this.isPoiPage
              ? '<v-btn color="error" id="delete-button">Obrisi</v-btn>'
              : ''
          }
        `
      })

      this.google.maps.event.addListener(circle, 'click', e => {
        this.selectedShape = circle
        this.infoWindow = infoWindow
        infoWindow.setPosition(e.latLng)
        infoWindow.open(this.$refs.map.$mapObject)

        setTimeout(() => {
          const element = document.getElementById('delete-button')
          if (element) {
            this.google.maps.event.addDomListener(
              element,
              'click',
              this.deleteLayer
            )
          }
        }, 100)
      })

      var that = this

      let smallInfo = new this.google.maps.InfoWindow({
        content: `<h3>${poi.name}</h3>`
      })
      this.google.maps.event.addListener(circle, 'mouseover', e => {
        smallInfo.setPosition(e.latLng)
        smallInfo.open(this.$refs.map.$mapObject)
        let editable = circle.editable

        if (!editable) {
          smallInfo.close(that.$refs.map.$mapObject)

          circle.setMap(null)
          circle.setMap(null)
          circle.infoWindow = null
          circle = null
          that.handleCircularPoiDrawing(poi, true)
        }
      })
      this.google.maps.event.addListener(circle, 'mouseout', e => {
        smallInfo.setPosition(e.latLng)
        smallInfo.close(this.$refs.map.$mapObject)
      })

      this.google.maps.event.addListener(circle, 'radius_changed', () => {
        this.handleCircleOverlayCreated(circle, 'CIRCLE')
      })

      this.google.maps.event.addListener(circle, 'center_changed', () => {
        this.handleCircleOverlayCreated(circle, 'CIRCLE')
      })

      circle.setMap(this.$refs.map.$mapObject)

      this.allLayers.push(circle)
    },
    // Polygon POI
    handlePolygonPoiDrawing(poi, editable = false) {
      if (this.infoWindow && this.infoWindow.setMap) {
        this.infoWindow.setMap(null)
        this.infoWindow = null
      }
      let coordinates = this.preparePolygonCoordinatesForGoogleMaps(
        poi.coordinates
      )
      let paths = coordinates
      let fillColor = poi.color
      let polygonProperties = {
        paths,
        fillColor,
        ...this.defaultElementConfig
      }
      let polygon = new this.google.maps.Polygon(polygonProperties)

      polygon._id = poi.id
      polygon._poiName = poi.name
      polygon._poiTime = poi.allowedStayMinutes
      polygon._color = poi.color
      polygon._restrictionType = poi.restriction
      polygon._type = poi.type

      polygon.editable = editable
      polygon.draggable = editable

      let infoWindow = new this.google.maps.InfoWindow({
        content: `
          <p>${poi.name}</p>
          ${
            this.isPoiPage
              ? '<v-btn color="error" id="delete-button">Obrisi</v-btn>'
              : ''
          }
        `
      })

      this.google.maps.event.addListener(polygon, 'click', e => {
        this.selectedShape = polygon
        this.infoWindow = infoWindow
        infoWindow.setPosition(e.latLng)
        infoWindow.open(this.$refs.map.$mapObject)

        setTimeout(() => {
          const element = document.getElementById('delete-button')
          if (element) {
            this.google.maps.event.addDomListener(
              element,
              'click',
              this.deleteLayer
            )
          }
        }, 100)
      })
      let smallInfo = new this.google.maps.InfoWindow({
        content: `<h3>${poi.name}</h3>`
      })

      var that = this
      this.google.maps.event.addListener(polygon, 'mouseover', e => {
        smallInfo.setPosition(e.latLng)
        smallInfo.open(this.$refs.map.$mapObject)
        let editable = polygon.editable

        if (!editable) {
          smallInfo.close(that.$refs.map.$mapObject)

          polygon.setMap(null)
          polygon.setMap(null)
          polygon.infoWindow = null
          polygon = null
          that.handlePolygonPoiDrawing(poi, true)
        }
      })
      this.google.maps.event.addListener(polygon, 'mouseout', e => {
        smallInfo.setPosition(e.latLng)
        smallInfo.close(this.$refs.map.$mapObject)
      })

      this.google.maps.event.addListener(polygon, 'dragend', () => {
        this.handlePolygonOverlayCreated(polygon, 'POLYGON')
      })

      this.google.maps.event.addListener(polygon.getPath(), 'set_at', () => {
        this.handlePolygonOverlayCreated(polygon, 'POLYGON')
      })

      this.google.maps.event.addListener(polygon.getPath(), 'insert_at', () => {
        this.handlePolygonOverlayCreated(polygon, 'POLYGON')
      })

      polygon.setMap(this.$refs.map.$mapObject)

      this.allLayers.push(polygon)
    },
    deleteLayer() {
      this.selectedShape.setMap(null)
      this.infoWindow.setMap(null)
      this.infoWindow = null
      remove(`/pois/${this.selectedShape._id}`)
      this.selectedShape = null
    },
    prepareCircleCoordinateForGoogleMaps(coordinate) {
      return {
        lat: coordinate.latitude,
        lng: coordinate.longitude
      }
    },
    preparePolygonCoordinatesForGoogleMaps(coordinates) {
      let googleMapCoordinates = []

      coordinates.forEach(coordinate => {
        googleMapCoordinates.push({
          lat: coordinate.latitude,
          lng: coordinate.longitude
        })
      })

      return googleMapCoordinates
    },
    zoomToRoute(route) {
      if (!route.length) {
        return
      }
      this.$refs.map.$mapPromise.then(map => {
        var bounds = new this.google.maps.LatLngBounds()
        route.forEach(vehicle => {
          bounds.extend(
            new this.google.maps.LatLng(vehicle.latitude, vehicle.longitude)
          )
        })

        map.fitBounds(bounds)
      })
    }
  }
}
</script>
